import type { PropsWithChildren } from 'react';
import type { BoxProps } from '../Core';
import { DropdownHeaderWrapper } from './styles';

export function DropdownHeader({ children, ...props }: PropsWithChildren<BoxProps>) {
  return <DropdownHeaderWrapper {...props}>{children}</DropdownHeaderWrapper>;
}
